/* eslint-disable @typescript-eslint/no-explicit-any */
// TODO: This file was automatically migrated to TypeScript by `dev typescript migrate`.
//  The eslint disable comment above should be removed and the resulting errors fixed.
import React from 'react';

import DataConnector from 'connect/DataConnector';
import {LabelTemplate} from 'constants/SampleConstants';
import * as LabelPrintingActions from 'label-printing/LabelPrintingActions';
import * as RegistryUtil from 'registry/RegistryUtil';
import StorableStore from 'samples/StorableStore';
import EditableItemTable from 'ui-library/EditableItemTable';
import * as modals from 'util/Modals';

class LabelTemplatesListingConnector extends DataConnector<LabelTemplatesListingProps, EnhancedProps> {
  props: any;
  storableStore: any;
  shouldSubscribeToRedux = false;
  stores = [StorableStore];

  enhanceProps(): EnhancedProps {
    return {labelTemplates: this.storableStore().getLabelTemplates(this.props.registryId)};
  }
}

export interface LabelTemplatesListingProps {
  isWritable: boolean;
  ownerUrlId: string;
  registryId: string;
}
interface EnhancedProps {
  labelTemplates?: Array<LabelTemplate>;
}

class LabelTemplatesListing extends React.Component<LabelTemplatesListingProps & EnhancedProps> {
  componentDidMount(): void {
    LabelPrintingActions.fetchLabelTemplates();
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  _getEditUrl = (index: any) => {
    const labelTemplateId = this.props.labelTemplates![index].id;
    return RegistryUtil.getLabelTemplateSettingsUrl(
      this.props.ownerUrlId,
      this.props.registryId,
      labelTemplateId
    );
  };

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  _handleDelete = (index: any) => {
    const labelTemplate = this.props.labelTemplates![index];
    modals
      .confirm(`Delete ${labelTemplate.name}`, 'Are you sure you want to delete this label template?')
      .done(() => {
        LabelPrintingActions.deleteLabelTemplate(labelTemplate.id);
      });
  };

  render(): JSX.Element {
    let rows;
    if (this.props.labelTemplates) {
      rows = this.props.labelTemplates.map((labelTemplate, i) => ({
        itemIndex: i,
        values: [labelTemplate.name],
      }));
    }
    const columnHeaders = [{name: 'Name', width: 12}];
    return (
      // @ts-expect-error ts-migrate(2741) FIXME: Property 'subheaderNode' is missing in type '{ col... Remove this comment to see the full error message
      <EditableItemTable
        columnHeaders={columnHeaders}
        emptyMessage="This registry has no label templates."
        isLoading={!this.props.labelTemplates}
        onDelete={this._handleDelete}
        getEditUrl={this._getEditUrl}
        rows={rows}
        writable={this.props.isWritable}
      />
    );
  }
}

export default LabelTemplatesListingConnector.connect(LabelTemplatesListing);
